// Style includes
import './_collection-footer.scss';